module.exports = __webpack_public_path__ + "img/11_Splenic-Flexure.4cd29bd6.png";